import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { UsersService } from 'src/app/api/admin/company/users.service';
import { SearchEmployeeComponent } from 'src/app/components/search-employee/search-employee.component';
declare var $: any;

@Component({
  selector: 'app-users-form',
  templateUrl: './users-form.component.html',
  styleUrls: ['./users-form.component.css']
})
export class UsersFormComponent implements OnInit {
  @ViewChild(SearchEmployeeComponent) SearchEmployeeComponent: any;

  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  change_password: boolean = false;

  // variables
  profiles: any = [];
  employeeSelected: any = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private userService: UsersService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      employee_id: [null],
      profile_id: [null],
      role_id: [null],
      username: [null, [Validators.required, Validators.minLength(2)]],
      name: [null],
      document: [null],
      email: [null, [Validators.email]],
      telephone: [null],
      password: [null],
      address: [null],
      change_password:[false]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.getProfileUsers();
    this.navigationTrackerService.initializeMenu(this.route);
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.userService.get(this.checkId).subscribe({
      next: (data: any) => {
        let _item = data.data;
        this.item.patchValue({
          document: _item.document,
          profile_id: _item.profile_id,
          role_id: _item.role_id,
          username: _item.username,
          email: _item.email,
          change_password: false,
        });

        this.selectedEmployeeSearch(_item.employee_data);

        setTimeout(() => {
          (<any>$('#user_password')).attr('disabled', true);
        }, 150);
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getProfileUsers() {
    this.userService.listProfilesUser().subscribe({
      next: (data: any) => {
        this.profiles = data.results;
        this.item.patchValue({
          profile_id: this.profiles[0].id
        });
      }
    });
  }

  selectedEmployeeSearch(item_: any) {
    this.employeeSelected = item_;
    this.item.patchValue({
      employee_id: item_.id
    });
  }

  removeEmployee() {
    this.employeeSelected = null;
    this.item.patchValue({
      employee_id: null
    });
    setTimeout(() => {
      this.SearchEmployeeComponent.focused();
    }, 150);
  }

  activeChangePassword() {
    if (this.change_password) {
      setTimeout(() => {
        (<any>$('#user_password')).removeAttr('disabled', false);
        (<any>$('#user_password')).focus();
      }, 50);
    }else{
      setTimeout(() => {
        (<any>$('#user_password')).attr('disabled', true);
      }, 50);
    }
  }

  onSubmit() {
    this.submitted = true;
    this.item.patchValue({
      change_password: this.change_password
    });
    
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      if (this.isEdit) {
        this.userService.update(this.checkId, this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.userService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/empresa/usuarios/lista']);
  }
}
